module.exports = __webpack_public_path__ + "static/img/otLogozx.e4dae37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/otLogozx.png
// module id = PlYn
// module chunks = 44